// extracted by mini-css-extract-plugin
export default {"DetailRow":"ConfirmBillingModal_DetailRow__BCf0O"};